import { Organization } from '../../domain/backoffice/organization/Organization';
import { OrganizationDTO } from '../../domain/backoffice/organization/OrganizationDTO';
import { OrganizationBaseMapper } from './OrganizationBaseMapper';
import ProjectBaseMapper from './ProjectBaseMapper';
import UserBaseMapper from './UserBaseMapper';

export class OrganizationMapper {
  static toDomain(raw: OrganizationDTO): Organization {
    const organization = OrganizationBaseMapper.toDomain(raw);
    const projects = raw.projects.map(ProjectBaseMapper.toDomain);
    const users = raw.users.map(UserBaseMapper.toDomain);

    return Organization.create({ ...organization.props, projects, users }, organization.id);
  }
}
